import { isEmptySlateDocument } from "../../../core/constants";
import {
  Configuration,
  ImageAndTextDetails,
  Section,
} from "../../../resources/modelTypes";
import { DisplayPhoto } from "../DisplayPhoto";
import { ThemedRichText } from "./ThemedRichText";
import { css } from "@emotion/react";
import { SmallHeadline } from "@minted/fancyclothes";
import { theme } from "@minted/minted-components";
import React, { memo } from "react";

const styles = {
  alignment: (isHorizontal: boolean) => css`
    ${isHorizontal &&
    css`
      display: flex;
      justify-content: center;
    `}
  `,
  horizontalPhoto: css`
    width: 40%;
  `,
  textContainer: (displayMode: string) => css`
    display: flex;
    flex-direction: column;

    ${(displayMode === "left" || displayMode === "right") &&
    css`
      margin-left: ${theme.spacing.x2};
      margin-right: ${theme.spacing.x2};
      width: 40%;
    `}

    ${displayMode === "top" &&
    css`
      margin-bottom: ${theme.spacing.x4};
    `}
    ${displayMode === "bottom" &&
    css`
      margin-top: ${theme.spacing.x4};
    `}
  `,
};

export type DisplayImageAndTextSectionProps = {
  configuration: Configuration;
  section: Section;
};

const DisplayImageAndTextSection = ({
  configuration,
  section,
}: DisplayImageAndTextSectionProps) => {
  const details = section.sectionDetails as ImageAndTextDetails;
  const isHorizontal =
    details.displayMode === "left" || details.displayMode === "right";

  const textContent = (
    <div css={styles.textContainer(details.displayMode)}>
      {Boolean(details.title) && <SmallHeadline>{details.title}</SmallHeadline>}
      {!isEmptySlateDocument(details.content) && (
        <ThemedRichText content={details.content} />
      )}
    </div>
  );

  return (
    <>
      <div css={styles.alignment(isHorizontal)}>
        {(details.displayMode === "right" ||
          details.displayMode === "bottom") &&
          textContent}
        {section.photo && (
          <div css={isHorizontal && styles.horizontalPhoto}>
            <DisplayPhoto configuration={configuration} section={section} />
          </div>
        )}
        {(details.displayMode === "left" || details.displayMode === "top") &&
          textContent}
      </div>
    </>
  );
};

const MemoizedDisplayImageAndTextSection = memo(DisplayImageAndTextSection);

export { MemoizedDisplayImageAndTextSection as DisplayImageAndTextSection };
